import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { addVehiclesToGroup } from '../../services/GroupsService';
import { Group, AddVehiclesToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddVehiclesToGroupRequest>;

function useAddVehiclesToGroup(successCb: (args: Group) => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(addVehiclesToGroup, {
    onSuccess: (data: Group) => {
      successCb(data);
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAddVehiclesToGroup;
